export const CREATE_REQUEST = 'CREATE_REQUEST';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';



const isFetching = (state = false, action) => {
  switch (action.type) {
    case CREATE_REQUEST:
      return true;
    case REQUEST_SUCCESS:
    case REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

export default isFetching;


// WEBPACK FOOTER //
// app/modules/app.js